import React, {useEffect, useRef} from 'react';
import { useDrag } from 'react-dnd';
import {getEmptyImage} from "react-dnd-html5-backend";

export default function DraggableItem({ item, sourceList, index, itemType = 'DRAGGABLE_ITEM', noStyle = false , onDragStart, onDragEnd}) {
    const dragRef = useRef(null); // Reference for the draggable element
    const [{ isDragging }, drag, preview] = useDrag({
        type: itemType,
        item: () => {
            onDragStart && onDragStart(); // Notify parent that dragging has started
            return { item, sourceList, index }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        canDrag: !item.disableDrag,
        end: () => {
            onDragEnd && onDragEnd(); // Notify parent that dragging has ended
        }
    });

    useEffect(() => {
        preview(getEmptyImage(), { captureDraggingState: true })
    }, [preview])

    let additionalStyle = {
        padding: '8px',
        margin: '4px',
        cursor: 'move',
    };

    if (noStyle) {
        additionalStyle = {};
    }

    return (
        <div
            ref={(node) => {
                drag(node); // Attach drag functionality
                dragRef.current = node; // Save reference to the DOM element
            }}
            style={{
                ...additionalStyle,
                opacity: isDragging ? 0.5 : 1,
                filter: isDragging ? 'grayscale(100%)' : 'none'
            }}
        >
            {item.content} {/* Render the content */}
        </div>
    );
}
